import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => ({
  links: {
    fontSize: '0.8rem',
    '& > a': {
      cursor: 'pointer',
      textTransform: 'uppercase',
      textDecoration: 'none',
      fontFamily: theme.fontFamilyArchivo,
      fontWeight: 600,
    },
    '& > a:not(:last-child)': {
      '&::after': {
        content: "' > '",
      },
    },
  },
  processedLink: {
    color: theme.darkSlateGrayColor,
  },
  unprocessedLink: {
    color: theme.silverColor,
  },
}));

export default useStyles;
